import type { Stuff } from "@69ly/shared";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

/** Where the single is used: each combo, execution and post-plant, linked. */
export function usedInLink(stuff: Stuff, u: NonNullable<Stuff["usedIn"]>[number]): string {
  if (u.kind === "combo") return `/combos/${u.id}`;
  if (u.kind === "execution") return `/library/${stuff.map}/executions?e=${u.id}`;
  return `/library/${stuff.map}/post-plant?spot=${u.id}`;
}

export function UsedInList({ stuff }: { stuff: Stuff }) {
  const { t } = useTranslation();
  const used = stuff.usedIn ?? [];
  if (used.length === 0) return <p className="muted small">{t("usedIn.none")}</p>;
  return (
    <ul className="used-in">
      {used.map((u) => (
        <li key={`${u.kind}-${u.id}`}>
          <span className="muted small">{t(`usedIn.${u.kind}`)}</span> <Link to={usedInLink(stuff, u)}>{u.title}</Link>
        </li>
      ))}
    </ul>
  );
}
